import { render, staticRenderFns } from "./Approvals.vue?vue&type=template&id=2fc40dbc"
import script from "./Approvals.vue?vue&type=script&lang=ts"
export * from "./Approvals.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports